// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__9WAie","notes":"Notes_notes__11IYE","note":"Notes_note__kl3yi","markdown":"Notes_markdown__2Sqkf"};